export default "__VITE_ASSET__D_4KS8Is__"